import { apiRequest } from './client'

/** A live call handed to a person: a teammate's dashboard rings until they accept, decline or miss it. */
export type Transfer = {
  id: string
  callId: string
  toUserId: string | null
  toName: string | null
  toPhone: string | null
  status: 'ringing' | 'accepted' | 'declined' | 'missed' | 'connected' | 'failed'
  reason: 'manual' | 'asked_for_person'
  createdAt: string
}

export type TransferTarget = { userId: string; name: string }

export const fetchAvailability = (orgId: string) =>
  apiRequest<{ isAvailable: boolean }>('GET', `/api/orgs/${orgId}/me/availability`)

export const setAvailability = (orgId: string, isAvailable: boolean) =>
  apiRequest<{ isAvailable: boolean }>('PATCH', `/api/orgs/${orgId}/me/availability`, { isAvailable })

export const fetchTransferTargets = (orgId: string) =>
  apiRequest<{ targets: TransferTarget[] }>('GET', `/api/orgs/${orgId}/transfer-targets`)

/** Rings a teammate (the shopper holds), or puts a phone call through to a number. */
export const transferCall = (orgId: string, callId: string, to: { toUserId: string } | { toPhone: string }) =>
  apiRequest<{ transfer: Transfer }>('POST', `/api/orgs/${orgId}/calls/${callId}/transfers`, to)

export const fetchRingingTransfers = (orgId: string) =>
  apiRequest<{ transfers: Transfer[] }>('GET', `/api/orgs/${orgId}/transfers/ringing`)

/** Answers the ring: the call is taken over from this browser (its offer goes with the answer). */
export const acceptTransfer = (orgId: string, transferId: string, offer: { sdp: string; type: 'offer' }) =>
  apiRequest<{ answer: { sdp: string; type: RTCSdpType } }>(
    'POST',
    `/api/orgs/${orgId}/transfers/${transferId}/accept`,
    offer,
  )

export const declineTransfer = (orgId: string, transferId: string) =>
  apiRequest('POST', `/api/orgs/${orgId}/transfers/${transferId}/decline`)
